import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "notice" }
const _hoisted_2 = { class: "notice-card" }
const _hoisted_3 = { class: "notice-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "modal-content1" }
const _hoisted_6 = { style: {"color":"black"} }
const _hoisted_7 = {
  class: "content",
  style: {"font-size":"30px","color":"black"}
}
const _hoisted_8 = { class: "meta" }
const _hoisted_9 = { style: {"color":"black"} }
const _hoisted_10 = { style: {"color":"black"} }

import { ref, onMounted } from 'vue'
import axios from '../../api/notice'
import PinnedNotice from '@/components/main/PinnedNotice.vue'



export default /*@__PURE__*/_defineComponent({
  __name: 'NoticeBoard',
  setup(__props) {

const notices = ref([]);

async function fetchNotice() {
  try {
    const response = await axios.ListNotice()
    notices.value = response.data
    console.log(response.data)
    notices.value = [pinnedNotice, ...response.data]
  } catch (error) {
    console.error('공지사항을 불러오는데 실패했습니다.:', error)
  }
}


const pinnedNotice = {
  id: 'pinned',
  title: '[고정] 사이트 이용방법',
  contentComponent: PinnedNotice,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  isPinned: true
}

const selectedNotice = ref(null)

function formatKoreanDateTime(dateString: string | null): string {
  if (!dateString) return '';
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0'); 
  return `${year}년 ${month}월 ${day}일 ${hours}시 ${minutes}분`;
}

function openPopup(item: any) {
  selectedNotice.value = item
}

function closePopup() {
  selectedNotice.value = null
}

onMounted(async () => {
  fetchNotice();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "notice-title" }, " 📢 공지사항 ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notices.value, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: "notice-item",
            onClick: ($event: any) => (openPopup(item))
          }, _toDisplayString(item.title), 9, _hoisted_4))
        }), 128))
      ])
    ]),
    (selectedNotice.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-overlay",
          onClick: _withModifiers(closePopup, ["self"])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(selectedNotice.value.title), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(selectedNotice.value.content), 1),
            (selectedNotice.value.contentComponent)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(selectedNotice.value.contentComponent), { key: 0 }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, " 등록일자: " + _toDisplayString(formatKoreanDateTime(selectedNotice.value.createdAt)), 1),
              _createElementVNode("p", _hoisted_10, " 수정일자: " + _toDisplayString(formatKoreanDateTime(selectedNotice.value.updatedAt)), 1)
            ]),
            _createElementVNode("button", {
              class: "close-btn",
              onClick: closePopup
            }, " 닫기 ")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})